(function() {
  'use strict';

  var debounceTimer;

  function getActiveColorFilters() {
    var params = new URLSearchParams(window.location.search);
    var colors = [];
    params.forEach(function(value, key) {
      if (key === 'filter.v.option.farve' && value) {
        colors.push(value.toLowerCase());
      }
    });
    return colors;
  }

  function hideNonMatchingVariants() {
    var activeColors = getActiveColorFilters();
    var items = document.querySelectorAll('#ProductGridContainer .grid__item');

    items.forEach(function(item) {
      if (activeColors.length === 0) {
        item.style.display = '';
        return;
      }

      var links = item.querySelectorAll('.card__heading a');
      var titleWithColor = '';
      links.forEach(function(link) {
        var text = link.textContent.trim();
        if (text.includes(' - ')) titleWithColor = text;
      });

      if (!titleWithColor) return;

      var dashIndex = titleWithColor.lastIndexOf(' - ');
      var cardColor = titleWithColor.substring(dashIndex + 3).toLowerCase();

      var matches = activeColors.some(function(filterColor) {
        return cardColor === filterColor;
      });

      item.style.display = matches ? '' : 'none';
    });
  }

  function debouncedHide() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(hideNonMatchingVariants, 50);
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    hideNonMatchingVariants();

    new MutationObserver(debouncedHide).observe(container, { childList: true, subtree: true });

    window.addEventListener('popstate', debouncedHide);
  }

  init();
})();
